import type { AppSettings, SettingsResponse, SettingsSection } from '../../shared/types/index.js';
import { request } from './client.js';

export async function fetchSettings(): Promise<AppSettings> {
  const { settings } = await request<SettingsResponse>('/settings');
  return settings;
}

export async function updateSettingsSection<K extends SettingsSection>(
  section: K,
  patch: Partial<AppSettings[K]>
): Promise<AppSettings> {
  const { settings } = await request<SettingsResponse>(`/settings/${section}`, { method: 'PATCH', body: patch });
  return settings;
}
